<app-grid #auditGrid [autoHeight]=true [cellEdit]="false" [columns]="auditColumns"
          [filter]="true" [showRemoveRowInContextMenu]="false" [width]="'100%'"
></app-grid>
